import React, { useContext, useEffect, useRef, useState } from "react";
import logo from "assets/images/logo.jpg";

import { Link, NavLink, useNavigate } from "react-router-dom";
import { Button, Dropdown, Modal, Form, Input, message } from "antd";
import { FiLogOut, FiLock, FiUser, FiDownload, FiHome, FiCalendar, FiCreditCard, FiBookOpen, FiUsers, FiGrid, FiPlayCircle, FiEdit3, FiMessageSquare, FiCompass, FiFlag, FiBriefcase, FiAward, FiTrendingUp } from "react-icons/fi";
import { onInstallable, promptInstall, isStandalone, isIOS } from "utils/pwa";
import { AuthContext } from "contexts";
import { instance } from "utils/axios";
import BurgerMenu from "./BurgerMenu";
import Notifications from "./Notifications";
import { HouseMark, houseOf } from "components/brand";

// Доод табын дүрс — замаас нь таана
const tabIcon = (path, active) => {
  const size = 20;
  if (path === "/") return <FiHome size={size} />;
  if (path === "/child") return <FiUsers size={size} />;
  if (path.includes("booking")) return <FiGrid size={size} />;
  if (path.includes("learning")) return <FiPlayCircle size={size} />;
  if (path.includes("exams")) return <FiEdit3 size={size} />;
  if (path === "/study") return <FiAward size={size} />;
  if (path === "/growth") return <FiTrendingUp size={size} />;
  if (path.includes("reflections")) return <FiMessageSquare size={size} />;
  if (path.includes("counseling")) return <FiCompass size={size} />;
  if (path === "/house") return <FiFlag size={size} />;
  if (path === "/school") return <FiBriefcase size={size} />;
  if (path.includes("payment") || path.includes("tuition")) return <FiCreditCard size={size} />;
  if (path.includes("college") || path.includes("prep")) return <FiBookOpen size={size} />;
  if (path.includes("children") || path.includes("guardian")) return <FiUsers size={size} />;
  return <FiCalendar size={size} />;
};

const items = [
  {
    key: "2",
    label: "Нууц үг солих",
    icon: <FiLock />,
  },
  {
    key: "1",
    label: "Гарах",
    icon: <FiLogOut />,
    danger: true,
  },
];

// ── Нууц үг солих modal (бүх role) ──
function ChangePasswordModal({ open, onClose }) {
  const [form] = Form.useForm();
  const [saving, setSaving] = useState(false);
  const submit = async (v) => {
    setSaving(true);
    try {
      await instance({ method: "put", url: "/applicant/password", data: { oldPassword: v.oldPassword, newPassword: v.newPassword } });
      message.success("Нууц үг амжилттай солигдлоо");
      form.resetFields();
      onClose();
    } catch (e) {
      // axios interceptor алдааг өөрөө харуулдаг
    } finally {
      setSaving(false);
    }
  };
  return (
    <Modal open={open} onCancel={() => { form.resetFields(); onClose(); }} footer={null} centered width={420} title="Нууц үг солих">
      <Form form={form} layout="vertical" onFinish={submit} style={{ marginTop: 12 }}>
        <Form.Item name="oldPassword" label="Одоогийн нууц үг" rules={[{ required: true, message: "Одоогийн нууц үгээ оруулна уу" }]}>
          <Input.Password autoComplete="current-password" />
        </Form.Item>
        <Form.Item name="newPassword" label="Шинэ нууц үг" rules={[{ required: true, message: "Шинэ нууц үгээ оруулна уу" }, { min: 6, message: "Хамгийн багадаа 6 тэмдэгт" }]}>
          <Input.Password autoComplete="new-password" />
        </Form.Item>
        <Form.Item name="confirm" label="Шинэ нууц үг давтах" dependencies={["newPassword"]}
          rules={[{ required: true, message: "Давтан оруулна уу" }, ({ getFieldValue }) => ({
            validator: (_, val) => !val || getFieldValue("newPassword") === val ? Promise.resolve() : Promise.reject(new Error("Нууц үг таарахгүй байна")),
          })]}>
          <Input.Password autoComplete="new-password" />
        </Form.Item>
        <Button type="primary" htmlType="submit" loading={saving} block style={{ background: "#5c1090", borderColor: "#5c1090", fontWeight: 700 }}>
          Хадгалах
        </Button>
      </Form>
    </Modal>
  );
}
// Сурагч: Нүүр · Сурлага · Хөгжил · Сургууль (+ Профайл). Өмнөх цэсүүд хасагдаагүй — шилжсэн:
// хуваарь, тусгал, захиалга → Нүүр; шалгалт → Сурлага; зөвлөгөө, хаус, их сургууль → Хөгжил; танхим захиалга → Сургууль.
const studentMenuBase = [
  { label: "Нүүр", path: "/", form: "home01" },
  { label: "Сурлага", path: "/study", form: "study01" },
  { label: "Хөгжил", path: "/growth", form: "growth01" },
  { label: "Сургууль", path: "/school", form: "school01" },
];

const headerMenu = [
  {
    label: "Нүүр",
    path: "/",
    form: "home01",
  },
  {
    label: "Төлбөр",
    path: "/paymentStatus",
    form: "payments01",
  },
  // {
  //   label: "Элсэлт",
  //   path: "/admissions",
  //   form: "admissions01",
  // },
  // {
  //   label: "Төлбөр",
  //   path: "/tuition",
  //   form: "tuition01",
  // },
  // {
  //   label: "Хичээл",
  //   path: "/lesson",
  //   form: "lesson01",
  // },
  // {
  //   label: 'POS',
  //   path: '/pos',
  // },
  // {
  //   label: 'RESOURCE',
  //   path: '/resource',
  // },
];
const applicantMenu = [
  {
    label: "Нүүр",
    path: "/",
    form: "homea01",
  },
];
// Мобайл доод табд эхний 4 нь гарна — хуваарь хүүхдийн хуудаснаас ч орно
const parentMenuBase = [
  {
    label: "Нүүр",
    path: "/",
    form: "homep01",
  },
  {
    label: "Хүүхэд",
    path: "/child",
    form: "child01",
  },
  {
    label: "Сургалт",
    path: "/learning",
    form: "learning01",
  },
  {
    label: "Төлбөрийн мэдээлэл",
    short: "Төлбөр",
    path: "/paymentstatus",
    form: "payments01",
  },
  {
    label: "Хичээлийн хуваарь",
    short: "Хуваарь",
    path: "/schedule",
    form: "timetable01",
  },
  {
    label: "Сургууль",
    path: "/school",
    form: "school01",
  },
];


function Header() {
  const navigate = useNavigate();
  const [showBurgerMenu, setShowBurgerMenu] = useState(false);
  const { action } = useContext(AuthContext);
  const { state } = useContext(AuthContext);
  const roleId = state.studentInfo?.profile?.roleId;
  // grade for menu-gating: use the cached login value, but also fetch fresh from
  // the server so users who logged in BEFORE grade was added still get gated
  // correctly (no re-login needed).
  const [grade, setGrade] = useState(state.studentInfo?.profile?.grade);
  const [housePres, setHousePres] = useState(!!state.studentInfo?.profile?.housePresident);
  // Нэвтэрсэн профайлыг серверээс нэг удаа шинэчилнэ — сурагчийн код/анги солигдсон
  // тохиолдолд хуучин код (QR!) хадгалагдаж үлдэхээс сэргийлнэ.
  const refreshedRef = useRef(false);
  useEffect(() => {
    // Токен контекстэд сэргээгдсэн хойно нэг л удаа ажиллана
    if (!state.studentInfo?.token || refreshedRef.current) return;
    refreshedRef.current = true;
    instance({ method: "get", url: "/applicant/profile" })
      .then((res) => {
        const p = res?.data;
        if (!p) return;
        if (p.grade != null) setGrade(p.grade);
        setHousePres(!!p.housePresident);
        const cur = state.studentInfo?.profile || {};
        if (p.code !== cur.code || p.grade !== cur.grade || p.roleId !== cur.roleId || p.firstName !== cur.firstName || p.imageUrl !== cur.imageUrl || p.houseId !== cur.houseId) action.refreshProfile(p);
      })
      .catch(() => { refreshedRef.current = false; });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.studentInfo?.token]);
  // Хаус (ерөнхийлөгч), их сургууль (11-р анги) — "Хөгжил" хуудсаас
  const studentMenu = studentMenuBase;

  const byPath = (p) => parentMenuBase.find((m) => m.path === p);
  // Эцэг эх: Нүүр · Хүүхэд · Сургууль (+ Профайл). Төлбөр, Сургалт, Passion, их сургууль — "Сургууль" хуудсанд; ирц, хуваарь — "Хүүхэд"-д
  const parentMenu = [byPath("/"), byPath("/child"), byPath("/school")];
  const [pwOpen, setPwOpen] = useState(false);
  // Олон рольтой (ж: багш + эцэг эх, эцэг эх + сурагч) хэрэглэгч рольдоо шилжих — шинэ token + profile
  const roles = state.studentInfo?.profile?.roles || [];
  const ROLE_NAMES = { 4: "Сурагч", 5: "Элсэгч", 6: "Эцэг эх" };
  const switchRole = (rid) => {
    if (rid == roleId) return;
    instance({ method: "post", url: "applicant/switch-role", data: { roleId: rid } })
      .then((res) => { action.login(res.data.token, res.data); setShowBurgerMenu(false); navigate("/"); window.location.reload(); })
      .catch(() => {});
  };
  const handleClickUser = (event) => {
    if (event.key === "1") {
      action.logout();
    } else if (event.key === "2") {
      setPwOpen(true);
    } else if (String(event.key).startsWith("role-")) {
      switchRole(Number(event.key.slice(5)));
    }
  };
  const handleClickBurgerMenu = (e) => {
    e.preventDefault();
    setShowBurgerMenu((prev) => !prev);
  };
  const menu =
    roleId == 5 ? applicantMenu : roleId == 4 ? studentMenu : roleId == 6 ? parentMenu : headerMenu;
  const profile = state.studentInfo?.profile || {};
  const initials = `${(profile.firstName || "?").charAt(0)}`.toUpperCase();
  const [imgOk, setImgOk] = useState(true);
  useEffect(() => setImgOk(true), [profile.imageUrl]);

  // Доод таб (мобайл): цэсний эхний 4 зүйл + Профайл
  const tabs = menu.slice(0, 4);
  const [installable, setInstallable] = useState(false);
  useEffect(() => onInstallable(setInstallable), []);

  const userMenu = {
    items: [
      { key: "who", label: <div className="px-1 py-1"><div className="font-semibold">{profile.firstName} {profile.lastName}</div><div className="text-xs text-gray-400">{profile.code || ""}</div></div>, disabled: true },
      { type: "divider" },
      ...(roles.length > 1
        ? [{ key: "roles", type: "group", label: "Роль солих", children: roles.map((r) => ({ key: `role-${r}`, label: (r == roleId ? "✓ " : "") + ROLE_NAMES[r] })) }, { type: "divider" }]
        : []),
      ...(installable && !isStandalone() ? [{ key: "3", label: "Апп болгож суулгах", icon: <FiDownload /> }] : []),
      ...items,
    ],
    onClick: (e) => {
      if (e.key === "3") promptInstall();
      else handleClickUser(e);
    },
  };

  return (
    <>
      {/* ── Дээд бар ── */}
      <header className="app-topbar fixed inset-x-0 top-0 z-50 bg-white/90 backdrop-blur border-b border-gray-100">
        <div className="h-[60px] max-w-6xl mx-auto px-4 md:px-6 flex items-center justify-between gap-3">
          <NavLink to="/" className="flex items-center gap-2 shrink-0">
            <img src={logo} alt="Tomujin" className="h-10 w-auto object-contain" />
          </NavLink>

          {/* Desktop нав */}
          <nav className="hidden md:flex items-center gap-1">
            {menu.map((m, i) => (
              <NavLink
                key={i}
                to={m.path}
                className={({ isActive }) =>
                  `px-3.5 h-10 inline-flex items-center gap-2 rounded-full text-[15px] transition-colors ${
                    isActive ? "bg-[#eee7f3] text-primary font-bold hover:text-primary" : "text-[#6e5e8a] font-semibold hover:bg-[#faf7ff] hover:text-primary"
                  }`
                }
              >
                <span className="hidden lg:inline-flex">{tabIcon(m.path)}</span>
                {menu.length > 4 ? m.short || m.label : m.label}
              </NavLink>
            ))}
          </nav>

          {/* Мэдэгдэл (эцэг эх) + хэрэглэгч */}
          <div className="flex items-center gap-1 shrink-0">
            {(roleId == 6 || roleId == 4) && <Notifications />}
            <Dropdown menu={userMenu} trigger={["click"]} placement="bottomRight">
              <button className="flex items-center gap-2 pl-1 pr-2 h-10 rounded-full hover:bg-gray-100 transition-colors">
                {/* Зураг → (зураггүй бол) хаусын лого → эхний үсэг */}
                {profile.imageUrl && imgOk
                  ? <img src={profile.imageUrl} alt="" referrerPolicy="no-referrer" onError={() => setImgOk(false)} className="h-8 w-8 rounded-full object-cover bg-[#f3eeff]" />
                  : houseOf(profile.houseId)
                    ? <HouseMark house={profile.houseId} size={32} />
                    : <span className="h-8 w-8 rounded-full bg-primary text-white font-bold flex items-center justify-center text-sm">{initials}</span>}
                <span className="hidden sm:block md:hidden lg:block text-left leading-tight">
                  <span className="block text-sm font-semibold text-gray-900 max-w-[120px] truncate">{profile.firstName || ""}</span>
                  {profile.code ? <span className="block text-[11px] text-gray-400">{profile.code}</span> : null}
                </span>
              </button>
            </Dropdown>
          </div>
        </div>
      </header>

      {/* ── Доод таб (мобайл) ── */}
      <nav className="app-tabbar md:hidden fixed inset-x-0 bottom-0 z-50 bg-white border-t border-gray-100">
        <div className="grid" style={{ gridTemplateColumns: `repeat(${tabs.length + 1}, minmax(0, 1fr))` }}>
          {tabs.map((m, i) => (
            <NavLink
              key={i}
              to={m.path}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center h-[64px] gap-1 text-xs ${
                  isActive ? "text-primary font-bold" : "text-[#6e5e8a] font-semibold"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <span className={`h-[30px] w-11 rounded-full flex items-center justify-center ${isActive ? "bg-[#eee7f3]" : ""}`}>
                    {tabIcon(m.path, isActive)}
                  </span>
                  <span className="max-w-[72px] truncate">{m.short || m.label}</span>
                </>
              )}
            </NavLink>
          ))}
          <button
            onClick={handleClickBurgerMenu}
            className="flex flex-col items-center justify-center h-[64px] gap-1 text-xs font-semibold text-[#6e5e8a]"
          >
            <span className="h-[30px] w-11 rounded-full flex items-center justify-center"><FiUser size={20} /></span>
            Профайл
          </button>
        </div>
      </nav>

      {/* Профайл/тохиргооны хуудас (мобайл) */}
      <BurgerMenu showMenu={showBurgerMenu} onClose={handleClickBurgerMenu}>
        <div className="flex flex-col">
          <div className="px-6 py-5 flex items-center gap-3 border-b border-gray-100">
            <span className="h-12 w-12 rounded-full bg-primary text-white font-bold flex items-center justify-center text-lg">{initials}</span>
            <div>
              <div className="font-semibold text-gray-900">{profile.firstName} {profile.lastName}</div>
              <div className="text-xs text-gray-400">{profile.code || ""}{profile.grade ? `${profile.code ? " · " : ""}${profile.grade}-р анги` : ""}</div>
            </div>
          </div>
          {roles.length > 1 && (
            <div className="px-6 py-3 border-b border-gray-50">
              <div className="text-[11px] text-gray-400 mb-1.5">Роль солих</div>
              <div className="flex gap-2 flex-wrap">
                {roles.map((r) => (
                  <button key={r} onClick={() => switchRole(r)} className={`pchip !h-8 !text-xs ${r == roleId ? "pchip-on" : "pchip-off"}`}>{ROLE_NAMES[r]}</button>
                ))}
              </div>
            </div>
          )}
          {menu.map((m, i) => (
            <NavLink key={i} to={m.path} onClick={() => setShowBurgerMenu(false)}
              className={({ isActive }) => `px-6 py-3 text-sm font-medium border-b border-gray-50 ${isActive ? "text-primary" : "text-gray-700"}`}>
              {m.label}
            </NavLink>
          ))}
          {installable && !isStandalone() && (
            <button className="flex items-center gap-2 px-6 py-3 text-sm font-medium text-primary" onClick={() => { setShowBurgerMenu(false); promptInstall(); }}>
              <FiDownload size={18} /> Апп болгож суулгах
            </button>
          )}
          {isIOS() && !isStandalone() && (
            <div className="px-6 py-3 text-xs text-gray-400">iPhone: Safari дээр <b>Share</b> → <b>Add to Home Screen</b> дарж апп болгоно</div>
          )}
          <button className="flex items-center gap-2 px-6 py-3 text-sm font-medium text-gray-700" onClick={() => { setShowBurgerMenu(false); setPwOpen(true); }}>
            <FiLock size={18} /> Нууц үг солих
          </button>
          <button className="flex items-center gap-2 px-6 py-3 text-sm font-medium text-red-500" onClick={() => action.logout()}>
            <FiLogOut size={18} /> Гарах
          </button>
        </div>
      </BurgerMenu>
      <ChangePasswordModal open={pwOpen} onClose={() => setPwOpen(false)} />
    </>
  );
}

export default Header;
